export class OnlineState {
    id: string;
    isOnline: boolean;

    constructor({ user_id, is_online }: { user_id: number; is_online: boolean }) {
        this.id = user_id.toString();
        this.isOnline = is_online;
    }
}
